import { IApi } from '../../../api'
import { createRequestTypes } from '../../../helpers/helpers'
import { createAction } from '../../types'

export const prefix = 'atlasai/prompts'

export const LIST_PROMPTS = createRequestTypes(prefix, 'LIST_PROMPTS')
export const [LIST_PROMPTS_REQUEST, LIST_PROMPTS_SUCCESS, LIST_PROMPTS_FAILURE] = LIST_PROMPTS

export const listPrompts = createAction((params?: object) => ({
  type: LIST_PROMPTS,
  promise: (api: IApi) => api.atlasAI.listPrompts(params),
  params,
}))

export const GET_PROMPT = createRequestTypes(prefix, 'GET_PROMPT')
export const [GET_PROMPT_REQUEST, GET_PROMPT_SUCCESS, GET_PROMPT_FAILURE] = GET_PROMPT

export const getPrompt = createAction((id: string) => ({
  type: GET_PROMPT,
  promise: (api: IApi) => api.atlasAI.getPrompt(id),
}))

export const ADD_PROMPT = createRequestTypes(prefix, 'ADD_PROMPT')
export const [ADD_PROMPT_REQUEST, ADD_PROMPT_SUCCESS, ADD_PROMPT_FAILURE] = ADD_PROMPT

export const addPrompt = createAction((data: object) => ({
  type: ADD_PROMPT,
  promise: (api: IApi) => api.atlasAI.addPrompt(data),
}))

export const UPDATE_PROMPT = createRequestTypes(prefix, 'UPDATE_PROMPT')
export const [UPDATE_PROMPT_REQUEST, UPDATE_PROMPT_SUCCESS, UPDATE_PROMPT_FAILURE] = UPDATE_PROMPT

export const updatePrompt = createAction((id: string, data: object) => ({
  type: UPDATE_PROMPT,
  promise: (api: IApi) => api.atlasAI.updatePrompt(id, data),
}))

export const DELETE_PROMPT = createRequestTypes(prefix, 'DELETE_PROMPT')
export const [DELETE_PROMPT_REQUEST, DELETE_PROMPT_SUCCESS, DELETE_PROMPT_FAILURE] = DELETE_PROMPT

export const deletePrompt = createAction((id: string) => ({
  type: DELETE_PROMPT,
  promise: (api: IApi) => api.atlasAI.deletePrompt(id),
}))

export const CLEAR_SELECTED_PROMPT = `${prefix}/CLEAR_SELECTED_PROMPT`

export const clearSelectedPrompt = () => ({ type: CLEAR_SELECTED_PROMPT })
